export default __webpack_public_path__ + "0d37e880f698e251549ff0d0b8a68311.png";